import _defineProperty from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _paymentMethodsToDisp;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-len */
import _ from 'lodash';
export var OrderFlows = {
  pickup: ['open', 'confirmed', 'closed'],
  delivery: ['open', 'confirmed', 'inTransit', 'closed']
};
export var MARKETING_CAMPAIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'dtm_campaign', 'dtm_medium', 'dtm_content'];
export var SPECIAL_INSTRUCTIONS_MAX_LENGTH = 500;
export var CURBSIDE_PICKUP_SPECIAL_INSTRUCTIONS = 'This order is for Curbside Pickup.\n';
export var DRIVE_THRU_PICKUP_SPECIAL_INSTRUCTIONS = 'This is a drive thru order.\n';
export var DELIVERY_CUSTOMER_ERROR = 'cannot submit multiple orders from same customer to this dispensary on same day';
export var DELIVERY_ADDRESS_ERROR = 'cannot submit multiple orders from same address to this dispensary on same day';
export var PAUSED_ORDERS_CLOSED_ERROR = "We're closed at the moment due to extremely high demand. Stay tuned though, we'll reopen soon!";
export var DELIVERY_ERRORS = {
  CUSTOMER: 'CUSTOMER',
  ADDRESS: 'ADDRESS'
};
export var POSTAL_CODE_ERROR = 'We were unable to verify your card information. Please ensure the postal code entered matches what is on file at your bank for this card.';
export var OrderFilterOptions = [{
  name: 'delivery-available',
  key: 'deliveryAvailable',
  label: 'Delivery Available'
}, {
  name: 'free-delivery',
  key: 'freeDelivery',
  label: 'Free Delivery'
}, {
  name: 'no-delivery-minimum',
  key: 'noDeliveryMinimum',
  label: 'No Delivery Minimum'
}, {
  name: 'accepts-credit-cards',
  key: 'acceptsCreditCards',
  label: 'Accepts Credit Cards'
}];
export var PAYMENT_CASH = 'cash';
export var PAYMENT_DUTCHIEPAY = 'dutchiePay';
export var PAYMENT_CREDIT_CARD = 'creditCard';

// Order of these keys is important for
// firstValidPaymentOption to work correctly.
// We want to start with in store, then cash
export var paymentMethodsToDisplayNames = (_paymentMethodsToDisp = {
  payInStore: 'In Store',
  inStore: 'In Store'
}, _defineProperty(_paymentMethodsToDisp, PAYMENT_CASH, 'Cash'), _defineProperty(_paymentMethodsToDisp, "check", 'Check'), _defineProperty(_paymentMethodsToDisp, PAYMENT_CREDIT_CARD, 'Credit Card'), _defineProperty(_paymentMethodsToDisp, "creditCardAtDoor", 'Credit Card'), _defineProperty(_paymentMethodsToDisp, "payOnlineHypur", 'Hypur'), _defineProperty(_paymentMethodsToDisp, "payOnlineMerrco", 'Credit Card'), _defineProperty(_paymentMethodsToDisp, "payOnlineMoneris", 'Credit Card'), _defineProperty(_paymentMethodsToDisp, "payOnlineChase", 'Credit Card'), _defineProperty(_paymentMethodsToDisp, "creditCardByPhone", 'Pay by Phone'), _defineProperty(_paymentMethodsToDisp, "inStoreCreditCard", 'Credit Card'), _defineProperty(_paymentMethodsToDisp, "credit", 'Credit Card'), _defineProperty(_paymentMethodsToDisp, "debitCard", 'Debit Card'), _defineProperty(_paymentMethodsToDisp, "debitOnly", 'Debit Card'), _defineProperty(_paymentMethodsToDisp, "debit", 'Debit Card'), _defineProperty(_paymentMethodsToDisp, "dutchiePay", 'Pay by Bank'), _defineProperty(_paymentMethodsToDisp, "rethinkPay", 'ReThink Wallet'), _defineProperty(_paymentMethodsToDisp, "linx", 'Linx'), _defineProperty(_paymentMethodsToDisp, "alt36", 'Alt Thirty Six'), _defineProperty(_paymentMethodsToDisp, "canPay", 'CanPay'), _defineProperty(_paymentMethodsToDisp, "paytender", 'Paytender'), _defineProperty(_paymentMethodsToDisp, "aeropay", 'Aeropay'), _paymentMethodsToDisp);
export var orderTypesToDisplayNames = {
  inStorePickup: 'In-Store Pickup',
  curbsidePickup: 'Curbside Pickup',
  driveThruPickup: 'Drive-Thru Pickup',
  delivery: 'Delivery',
  kiosk: 'Kiosk'
};
export var orderTypesToShortNamesV2 = {
  inStorePickup: 'In-Store',
  curbsidePickup: 'Curbside',
  driveThruPickup: 'Drive-Thru',
  delivery: 'Delivery'
};
export var paysafeCardTypes = {
  VI: 'Visa',
  MC: 'Mastercard',
  // mastercard credit
  MD: 'Mastercard',
  // mastercard debit
  AM: 'Amex',
  DI: 'Discover'
};
export var paymentMethodsToDisplayNamesAdmin = _objectSpread(_objectSpread({}, paymentMethodsToDisplayNames), {}, {
  payOnlineMerrco: 'Credit Card (Merrco)',
  payOnlineMoneris: 'Credit Card (Moneris)',
  payOnlineChase: 'Credit Card (Chase)',
  dutchiePay: 'Pay by Bank',
  rethinkPay: 'ReThink Wallet'
});
export var validOrderTypes = Object.keys(orderTypesToDisplayNames);
export var firstValidPaymentOption = function firstValidPaymentOption() {
  var dispensary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!dispensary.cashless) {
    return 'cash';
  }
  if (dispensary.payOnlineMerrco) {
    return 'creditCard';
  }
  var foundMethod = _.find(_.keys(paymentMethodsToDisplayNames), function (key) {
    return dispensary[key];
  }) || _.keys(paymentMethodsToDisplayNames)[0];
  return foundMethod;
};
export var defaultDurationEstimates = {
  delivery: {
    lowInMinutes: 35,
    highInMinutes: 45
  },
  pickup: {
    lowInMinutes: 15,
    highInMinutes: 25
  },
  curbsidePickup: {
    lowInMinutes: 15,
    highInMinutes: 25
  }
};
export var defaultActionEstimates = {
  pickup: {
    readyInMinutes: 20,
    rangeInMinutes: 5
  },
  delivery: {
    readyInMinutes: 25,
    rangeInMinutes: 10,
    deliveryTimeInMinutes: 20
  }
};

// valid id's enum - graphql/order/type.js
export var archiveReasons = function archiveReasons() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$phone = _ref.phone,
    phone = _ref$phone === void 0 ? '' : _ref$phone,
    _ref$orderId = _ref.orderId,
    orderId = _ref$orderId === void 0 ? '' : _ref$orderId;
  return [{
    id: 'NOPICKUP',
    reason: 'Customer never picked up the order',
    customerMessage: "Your order #".concat(orderId, " was canceled because it wasn't picked up. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }, {
    id: 'SOLDOUT',
    reason: 'Items on the order were sold out',
    customerMessage: "Your order #".concat(orderId, " contained a sold-out item and has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }, {
    id: 'CANCELLED',
    reason: 'Customer asked to cancel the order',
    customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }, {
    id: 'NOPAYMENT',
    reason: 'Customer didn’t have proper payment',
    customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }, {
    id: 'NOIDENTIFICATION',
    reason: 'Customer didn’t have proper identification',
    customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }, {
    id: 'BADINFO',
    reason: 'Customer entered their information incorrectly',
    customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }, {
    id: 'COMPLIANCEVIOLATION',
    reason: 'The order violated compliance',
    customerMessage: "Your order #".concat(orderId, " has been canceled for compliance reasons. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }, {
    id: 'OTHER',
    reason: 'Other',
    customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
  }];
};
export var orderTypeToIndex = {
  pickup: 0,
  delivery: 1
};
export var ORDER_TYPE_DELIVERY = 'delivery';
export var ORDER_TYPE_PICKUP = 'pickup';
export var indexToOrderType = [ORDER_TYPE_PICKUP, ORDER_TYPE_DELIVERY];
export var RewardsConnectionStatuses = {
  ready: 'ready',
  processing: 'processing',
  failed: 'failed',
  succeeded: 'succeeded'
};
export var RewardsBrands = {
  alpineiq: 'alpineiq'
};
export var CHECKOUT_LINE_ITEM_MAPPING = {
  subtotal: 'productSubtotal',
  taxes: 'totalTax',
  discounts: 'discount',
  rewards: 'reward',
  bottleDeposit: 'bottleDepositTaxCents',
  sales: 'salesTax',
  cannabis: 'cannabisTax',
  delivery: 'deliveryFee',
  payment: 'paymentFee',
  other: 'otherFees'
};